import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Waves_ds_get_orders_by_orderIdsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { orderIds: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, OrderClassId?: number, OrderStatusId?: number, PreferredCarrierId?: number, PreferredCarrierServiceTypeId?: number, PreferredWarehouseId?: number, RequestedDeliveryDate?: string, OrderClass?: { OrderClassTypeId?: number, OrderTypeId?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderIds)) {
      missingRequiredInParams.push('\'orderIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Waves/datasources/ds_get_orders_by_orderIds/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { orderIds: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, OrderClassId?: number, OrderStatusId?: number, PreferredCarrierId?: number, PreferredCarrierServiceTypeId?: number, PreferredWarehouseId?: number, RequestedDeliveryDate?: string, OrderClass?: { OrderClassTypeId?: number, OrderTypeId?: number } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderIds)) {
      missingRequiredInParams.push('\'orderIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Waves/datasources/ds_get_orders_by_orderIds/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { orderIds: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, OrderClassId?: number, OrderStatusId?: number, PreferredCarrierId?: number, PreferredCarrierServiceTypeId?: number, PreferredWarehouseId?: number, RequestedDeliveryDate?: string, OrderClass?: { OrderClassTypeId?: number, OrderTypeId?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderIds)) {
      missingRequiredInParams.push('\'orderIds\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Waves/datasources/ds_get_orders_by_orderIds/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      orderIds: number[]    }) {
        if(isNil(inParams.orderIds)) {
          return true; 
        }
      return false;
    }
}
